import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

class TehnoShipmentsDAO {
  static async get(shipmentId: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('tehnoShipments.get', { shipmentId });
  }
}

export default TehnoShipmentsDAO;
